import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

import PendingComponent from "@/globalComponents/atoms/PendingComponent"
import ErrorComponent from "@/globalComponents/organisms/ErrorComponent"
import { log } from "@/utilities/logging"
import welcomeTokenStorage from "@/utilities/WelcomeTokenStorage"

export const Route = createFileRoute("/qr/$qrLookupID")({
  beforeLoad: async ({ params, matches }) => {
    // Receipt pages are deep-linkable without a welcome token
    if (matches.some((m) => m.routeId === "/qr/$qrLookupID/receipt/$receiptID"))
      return

    // Validate qrLookupID against stored session data
    const storedQrLookupID = welcomeTokenStorage.getQrLookupID()

    if (storedQrLookupID && storedQrLookupID !== params.qrLookupID) {
      // QR has changed - clear old session data and redirect to welcome with the new QR
      // This will generate a new token with the current QR lookup ID

      log({
        level: "log",
        flow: "misc",
        scope: "guard.qrLookupID",
        message: "QrLookup Changed",
        meta: {
          storedQrLookupID,
          suppliedQrLookupID: params.qrLookupID,
        },
      })

      welcomeTokenStorage.removeToken()

      throw redirect({
        to: "/qr/$qrLookupID/welcome",
        params: { qrLookupID: params.qrLookupID },
      })
    }
  },
  loader: ({ context }) => {
    context.setDocumentThemeMode("whiteLabel")
  },
  preload: false,
  pendingComponent: PendingComponent,
  // notFoundComponent: (opts) => <RootNotFound {...opts} />,
  errorComponent: (opts) => (
    <ErrorComponent {...opts} resolution="restartFromWelcome" />
  ),
  component: Outlet,
})
